import { queryClient } from "App";
import { get } from "lodash";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { SOURCE_STATUSES_TABLE_CONSTANTS } from "components/source_statuses_table/SourceStatusesTableV3";
import { getSourceStatusesTableColumns } from "components/source_statuses_table/SourceStatusesTableColumnsAndFilters";
import UserService from "services/User";
import { addResizedColumns } from "hooks/useTableConfig";

export const invalidateSourceStatusesQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [SOURCE_STATUSES_TABLE_CONSTANTS.queryKey],
  });
};

export const useSourceStatusesTable = () => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getSourceStatusesTableColumns();

    const sourceStatusesTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${SOURCE_STATUSES_TABLE_CONSTANTS.tableName}`,
      {}
    );

    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: sourceStatusesTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched]);

  return { columns };
};
